webpackJsonp([214683911947493],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/snow-removal-wisconsin-illinois.8bd405f5.jpg";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	var _snowRemovalWisconsinIllinois = __webpack_require__(481);
	
	var _snowRemovalWisconsinIllinois2 = _interopRequireDefault(_snowRemovalWisconsinIllinois);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SnowRemoval = function SnowRemoval() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Salting, DeIcing, and Snow Removal | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Snow Removal'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We offer a wide range of custom solutions.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'col' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        ),
	        ' > ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services' },
	          'Services'
	        ),
	        ' > Snow Removal'
	      ),
	      _react2.default.createElement('img', { src: _snowRemovalWisconsinIllinois2.default, alt: 'snow removal from ICE enterprises' }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Professional snow removal & salting'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Snow removal and salting improves the safety of your commercial property. Ensure peace of mind this winter by hiring a professional and budget friendly team. ICE offers seasonal contracts paid monthly where snowfall is estimated. As well as per push projects which is charged based on the amount of snowfall.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Snow Relocation'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'ICE offers relocation, which involves moving large bodies of snow to new location to clear up space. We can move the snow to another location on the property. Or we can incorporate a dump truck to bring the snow to an offsite location.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Salting'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Salting and DeIcing of roadways and sidewalks involves applying chemicals to remove ice and prevent and delay reformation of ice. ICE provides salting for projects of any scale. We offer basic salting as well as solutions made for -30deg. We also offer specialized solutions like triple melt.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:estimates@ice2010.com', target: '__blank' },
	          'Contact us today'
	        ),
	        ' to talk about our tailored salting plans.'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = SnowRemoval;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-snow-removal-js-ce5495c7c77c71bfc048.js